import React, { Component } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

class CallAction extends Component {
    static contextType = LanguageContext;

    render() {
        const { language } = this.context;
        const t = translations[language];

        return (
            <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner text-center">
                                <span>{t.homepage.callAction?.readyText || 'READY TO BUILD SOMETHING GREAT?'}</span>
                                <h2>{t.homepage.callAction?.heading || "Let's Build Your Vision"}</h2>
                                <a className="rn-button-style--2" href="/contact"><span>{t.homepage.callAction?.button || 'Start Your Project'}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CallAction;